import { Badge, Box, CircularProgress, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import logo from '../../../assets/images/logo-black.svg';
import logoWhite from '../../../assets/images/logo-white.svg';
import cognitoService from '../../../core/service/cognito.service';
import styles from './navDesktop.module.scss';
import { SET_USER_DATA, SOCKET_DISCONNNECT } from '../../../constants/actionTypes';
import colors from '../../../utils/colors';

const mapStateToProps = (state) => ({
    isAdmin: state.user.currentUser.groups && state.user.currentUser.groups.includes('Admin'),
    user: state.user.currentUser
});

const mapDispatchToProps = (dispatch) => ({
    onLogout: () => {
        dispatch({
            type: SET_USER_DATA,
            payload: {
                data: null,
                token: null,
                loaded: true,
                imagePreview: null,
                name: null,
                nickname: null,
                step: false,
                surname: null,
                username: null
            }
        });
        dispatch({ type: SOCKET_DISCONNNECT });
    }
});

const NavDesktop = (props) => {
    const { t } = useTranslation();
    const path = window.location.pathname;
    const history = useHistory();

    const deleteCookie = (name) => {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    };

    const onLogout = () => {
        cognitoService.logoutUser();
        props.onLogout();
        deleteCookie('PremiumStatus');
        history.push('/');
    };
    return (
        <Box className={`${styles.flexBetween} ${props.hasBackground ? styles.overlay : ''}`}>
            <Box className={styles.flex}>
                <img
                    style={{ cursor: 'pointer', width: '40px', height: '40px' }}
                    onClick={() => history.push(props.isAdmin ? '/home' : '/my-library')}
                    src={path.includes('profile') ? logoWhite : logo}
                    alt="logo"
                />
                <Box className={styles.flexNav}>
                    {/* <Link>{t('About')}</Link> */}
                    <Link to={'/terms-and-conditions'}>{t('TermsAndConditions')}</Link>
                </Box>
            </Box>
            {props.user?.data && (
                <Box
                    className={styles.rightButtons}
                    sx={{
                        backgroundColor:
                            path === '/my-library' ||
                            path.includes('edit') ||
                            path.includes('watch') ||
                            path === '/terms-and-conditions'
                                ? '#EBF0EC !important'
                                : ''
                    }}>
                    <Box
                        onClick={() => history.push('/my-library')}
                        className={
                            path === '/my-library' ? styles.primaryButton : styles.whiteButton
                        }
                        sx={
                            props?.publishingVideos?.length
                                ? {
                                      width: '12vw !important',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center'
                                  }
                                : {}
                        }>
                        {props?.publishingVideos?.length > 0 && (
                            <span style={{ marginRight: '1rem' }}>
                                <Tooltip
                                    title={
                                        props?.publishingVideos?.length === 1
                                            ? `${props?.publishingVideos[0]?.title} is being published`
                                            : `${props?.publishingVideos?.length} videos are being published`
                                    }
                                    arrow>
                                    <Badge
                                        badgeContent={props.publishingVideos.length}
                                        anchorOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right'
                                        }}
                                        sx={{
                                            '& .MuiBadge-badge': {
                                                backgroundColor: props.badgeColor ?? colors.primary,
                                                color: 'black',
                                                minWidth: '15px',
                                                height: '15px',
                                                fontSize: '0.7rem',
                                                padding: '0'
                                            }
                                        }}>
                                        <CircularProgress
                                            sx={{
                                                width: '20px !important',
                                                height: '20px !important',
                                                color: props.spinnerColor ?? colors.primary
                                            }}
                                        />
                                    </Badge>
                                </Tooltip>
                            </span>
                        )}
                        {t('MyLibrary')}
                    </Box>
                    {props.isAdmin && (
                        <Box
                            onClick={() => history.push('/profile')}
                            className={
                                path === '/profile' ? styles.secondaryButton : styles.whiteButton
                            }>
                            {t('Profile')}
                        </Box>
                    )}
                    <Box
                        onClick={onLogout}
                        className={path === '/profile' ? styles.whiteButton : styles.blackButton}>
                        {t('SignOut')}
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(NavDesktop);
